export const flatten = (arr: any[]): any[] => {
  return arr.reduce(function (a, b) {
    return a.concat(Array.isArray(b) ? flatten(b) : b);
  }, []);
};

export function getNameFromEmail(email: string) {
  const atIndex = email.indexOf("@");

  if (atIndex === -1) {
    return null;
  }

  return email.substring(0, atIndex);
}
